import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCards() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="seo-guides" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Vigorbuy Spreadsheet Guides & Resources
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Explore our in-depth articles covering everything from getting started to advanced techniques, comparisons, and security guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              onClick={handleClick}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all duration-200 whitespace-nowrap">
                  Read Article
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}